import React, { FC, UIEvent } from "react"
import { KyzzenUser } from "../../../types"
import { MiniDeLoading } from "../../../components/DeLoading"
import UserTableAction from "./UserTableAction"

type Props = {
  users: KyzzenUser[]
  isLoading: boolean
  fetchMore: () => void
  onViewUser: (user: KyzzenUser) => void
  onDeleteUser: (user: KyzzenUser) => void
}

const UserTable: FC<Props> = ({
  users,
  isLoading,
  fetchMore,
  onViewUser,
  onDeleteUser,
}) => {
  const onTableScroll = (e: UIEvent<HTMLDivElement>) => {
    const target = (e.target || e.currentTarget) as HTMLTableElement
    if (
      Math.ceil(target?.clientHeight + target?.scrollTop) ===
      target?.scrollHeight
    ) {
      // handle lazy load here.
      fetchMore()
    }
  }
  return (
    <div className="h-full rounded-x10 border-spacing-y-10 border-spacing-x-0 overflow-hidden border border-kyzzen-secondary">
      <div
        className="app-table w-full overflow-auto h-full block"
        onScroll={onTableScroll}
      >
        <table className="rounded-lg border-separate border-spacing-0">
          <thead>
            <tr>
              <th className="w-[1%] px-2.5 py-3 whitespace-nowrap group/th font-medium text-sm text-accent-main border-b border-kyzzen-secondary sticky top-0 bg-kyzzen-primary">
                #
              </th>
              <th
                align="left"
                className="max-w-xs w-1/12 px-2.5 py-3 font-medium text-sm whitespace-nowrap group/th text-accent-main border-b border-kyzzen-secondary sticky z-1 top-0 left-0 bg-kyzzen-primary"
              >
                Kyzzen profile
              </th>
              <th
                align="left"
                className="max-w-xs w-1/12 px-2.5 py-3 font-medium text-sm whitespace-nowrap group/th text-accent-main border-b border-kyzzen-secondary sticky top-0 bg-kyzzen-primary"
              >
                Email
              </th>
              <th
                align="left"
                className="max-w-xs w-1/12 px-2.5 py-3 font-medium text-sm whitespace-nowrap group/th text-accent-main border-b border-kyzzen-secondary sticky top-0 bg-kyzzen-primary"
              >
                Discord
              </th>
              <th
                align="left"
                className="max-w-xs w-1/12 px-2.5 py-3 font-medium text-sm whitespace-nowrap group/th text-accent-main border-b border-kyzzen-secondary sticky top-0 bg-kyzzen-primary"
              >
                Telegram
              </th>
              <th
                align="left"
                className="max-w-xs w-1/12 px-2.5 py-3 font-medium text-sm whitespace-nowrap group/th text-accent-main border-b border-kyzzen-secondary sticky top-0 bg-kyzzen-primary"
              >
                Twitter handle
              </th>
              <th
                align="right"
                className="max-w-xs w-1/12 px-2.5 py-3 font-medium text-sm whitespace-nowrap group/th text-accent-main border-b border-kyzzen-secondary sticky top-0 bg-kyzzen-primary"
              >
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            {isLoading ? (
              <tr>
                <td colSpan={7}>
                  <MiniDeLoading />
                </td>
              </tr>
            ) : users?.length ? (
              users.map((user, idx) => (
                <tr key={user.id} className="group/tbr">
                  <th className="w-[1%] px-2.5 py-3 whitespace-nowrap border-b border-kyzzen-secondary text-sm font-normal [tr:last-of-type_&]:border-b-0">
                    {idx + 1}
                  </th>
                  <td
                    align="left"
                    className="max-w-xs px-2.5 py-3 text-sm whitespace-nowrap group/td font-normal border-b border-kyzzen-secondary sticky left-0 bg-kyzzen-primary truncate [tr:last-of-type_&]:border-b-0"
                  >
                    {user.username}
                  </td>
                  <td
                    align="left"
                    className="max-w-xs px-2.5 py-3 text-sm whitespace-nowrap group/td font-normal border-b border-kyzzen-secondary truncate [tr:last-of-type_&]:border-b-0"
                  >
                    {user.email}
                  </td>
                  <td
                    align="left"
                    className="max-w-xs px-2.5 py-3 text-sm whitespace-nowrap group/td font-normal border-b border-kyzzen-secondary truncate [tr:last-of-type_&]:border-b-0"
                  >
                    {user.discord_username}
                  </td>
                  <td
                    align="left"
                    className="max-w-xs px-2.5 py-3 text-sm whitespace-nowrap group/td font-normal border-b border-kyzzen-secondary truncate [tr:last-of-type_&]:border-b-0"
                  >
                    {user.telegram_username}
                  </td>
                  <td
                    align="left"
                    className="max-w-xs px-2.5 py-3 text-sm whitespace-nowrap group/td font-normal border-b border-kyzzen-secondary truncate [tr:last-of-type_&]:border-b-0"
                  >
                    {user.twitter_username}
                  </td>
                  <td
                    align="right"
                    className="max-w-xs px-2.5 py-3 text-sm whitespace-nowrap group/td font-normal border-b border-kyzzen-secondary [tr:last-of-type_&]:border-b-0"
                  >
                    <UserTableAction
                      onViewUser={() => onViewUser(user)}
                      onDeleteUser={() => onDeleteUser(user)}
                    />
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={7}>
                  <div className="flex h-48 items-center justify-center">
                    No data
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default UserTable
